var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-primary btn--bigger",
                on: { click: _vm.cerrar }
              },
              [
                _c("i", { staticClass: "fa fa-times" }),
                _vm._v(" "),
                _c("span", [_vm._v("Cerrar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-info btn--bigger",
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v(" "),
                _c("span", [_vm._v("Consultar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field select2-field--stretch" },
                  [
                    _c("v-select", {
                      attrs: {
                        placeholder: "Seleccione...",
                        id: "doctor",
                        options: _vm.doctores,
                        label: "nombre_cabecera"
                      },
                      on: { input: _vm.inputDoctor },
                      model: {
                        value: _vm.selectedDoctor,
                        callback: function($$v) {
                          _vm.selectedDoctor = $$v
                        },
                        expression: "selectedDoctor"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "doctor" } }, [
                      _vm._v("Médico")
                    ]),
                    _vm._v(" "),
                    _vm.errores.doctor_id
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.doctor_id[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-9" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c("label", { attrs: { for: "hoy" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: {
                      value: "H",
                      type: "radio",
                      name: "tipo_fecha",
                      id: "hoy"
                    },
                    domProps: { checked: _vm._q(_vm.form.tipo_fecha, "H") },
                    on: {
                      change: [
                        function($event) {
                          return _vm.$set(_vm.form, "tipo_fecha", "H")
                        },
                        _vm.consultar
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Hoy")])
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "ayer" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: {
                      value: "A",
                      type: "radio",
                      name: "tipo_fecha",
                      id: "ayer"
                    },
                    domProps: { checked: _vm._q(_vm.form.tipo_fecha, "A") },
                    on: {
                      change: [
                        function($event) {
                          return _vm.$set(_vm.form, "tipo_fecha", "A")
                        },
                        _vm.consultar
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Ayer")])
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "personalizado" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: {
                      value: "P",
                      type: "radio",
                      name: "tipo_fecha",
                      id: "personalizado"
                    },
                    domProps: { checked: _vm._q(_vm.form.tipo_fecha, "P") },
                    on: {
                      change: [
                        function($event) {
                          return _vm.$set(_vm.form, "tipo_fecha", "P")
                        },
                        _vm.changePersonalizado
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Personalizado")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.tipo_fecha === "P",
                        expression: "form.tipo_fecha === 'P'"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "desde",
                            label: "YYYY-MM-DD",
                            locale: "es",
                            "no-label": "",
                            "only-date": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD"
                          },
                          model: {
                            value: _vm.form.desde,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "desde", $$v)
                            },
                            expression: "form.desde"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "desde" } }, [
                          _vm._v("Desde")
                        ]),
                        _vm._v(" "),
                        _vm.errores.desde
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.desde[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.tipo_fecha === "P",
                        expression: "form.tipo_fecha === 'P'"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "hasta",
                            locale: "es",
                            "no-label": "",
                            "only-date": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            label: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD"
                          },
                          model: {
                            value: _vm.form.hasta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "hasta", $$v)
                            },
                            expression: "form.hasta"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "hasta" } }, [
                          _vm._v("Hasta")
                        ]),
                        _vm._v(" "),
                        _vm.errores.hasta
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.hasta[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card mt-2" }, [
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card__content" },
          [
            _c("k-table", {
              ref: "cierres",
              attrs: {
                buscarButton: false,
                filterStatus: false,
                params: _vm.form,
                path: _vm.path,
                createButton: false,
                editButton: false,
                deleteButton: false,
                buttons: [
                  {
                    icon: "fa-user-md",
                    event: "verDoctores",
                    class: "btn-info",
                    tooltip: "Ver médicos"
                  },
                  {
                    icon: "fa-edit",
                    event: "editarCierre",
                    class: "btn-primary",
                    tooltip: "Editar"
                  },
                  {
                    icon: "fa-ban",
                    event: "desconciliar",
                    class: "btn-danger",
                    tooltip: "Anular cierre"
                  }
                ],
                columns: [
                  {
                    display: "Fecha de inicio",
                    value: "fecha_inicio"
                  },
                  {
                    display: "Fecha de corte",
                    value: "fecha_corte"
                  },
                  {
                    display: "Total en consultas",
                    value: "total_consultas"
                  },
                  {
                    display: "Total cancelado",
                    value: "total_cancelado"
                  },
                  {
                    display: "Consultas",
                    value: "consultas_totales"
                  },
                  {
                    display: "Observación",
                    value: "observacion"
                  }
                ]
              },
              on: {
                errores: _vm.onErrores,
                verDoctores: _vm.verDoctores,
                editarCierre: _vm.editarCierre,
                desconciliar: _vm.desconciliar
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "doctores",
            scrollable: "",
            width: "50%",
            height: "auto",
            adaptive: "",
            reset: "",
            resizable: ""
          }
        },
        [
          _c("doctores-cierre-pago", {
            attrs: { id: _vm.currentId },
            on: { cerrar: _vm.cerrarDoctores }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Consulta de cierre de pagos")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Filtros de la consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Resultados de la consulta")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2457b962", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2457b962","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/procesos/ConsultaCierrePagos.vue
// module id = 585
// module chunks = 0